// Timer

export const ABORT_MODAL_TIMER = 30000;  // abort Modal after CallBeginn 
export const END_MODAL_TIMER = 800;     // show Modal after CallEnd 
export const PARKING_INTERVAL = 5000;   // Interval to refresh ParingList
export const ACD_INTERVAL = 5000;       // Interval to check incomming Calls
export const ACD_RESET_STATUS_TIMER = 3000; //after CallEnd and acdResetStatusTimer, send Reset/Agent is free) to ACD


// END Timer

export function acdText(typ) {
      // ToDo move to a config file -> i18n
      const acds = [
        { 'acd': '',  'text': 'Off'},
        { 'acd': '0',  'text': 'Off'},
        { 'acd': '1',  'text': '4Com'},
        { 'acd': '2',  'text': 'Intelegence',},
        { 'acd': '3',  'text': 'NFON'},
        { 'acd': '4',  'text': 'RauterIt'},
      ];
      let acd = _.find(acds, ['acd', typ]);
      return typeof(acd) != 'undefined' ? acd.text : 'Off';
    };


export function aclText(typ) {
      // ToDo move to a config file -> i18n
      const acls = [
        { 'acl': '210',  'text': 'KD-Mitarbeiter'},
        { 'acl': '220',  'text': 'KD-Agent'},
        { 'acl': '255',  'text': 'KD-Supervisor',},
        { 'acl': '550',  'text': 'CC-Agent'},
        { 'acl': '555',  'text': 'CC-Supervisor'},
        { 'acl': '560',  'text': 'CC-Admin'},
        { 'acl': '666',  'text': 'PGM-Supervisor'},
        { 'acl': '777',  'text': 'Admin'},
      ];
      let acl = _.find(acls, ['acl', typ]);
      return typeof(acl) != 'undefined' ? acl.text : '';
    };



// WEBPACK FOOTER //
// ./src/common/misc.conf.js